import {
  BD_RESOURCES_LIST_OPTIONS_DETAIL_LINK_FNC_DEFAULT,
  BD_RESOURCES_LIST_OPTIONS_DISABLE_FNC_DEFAULT,
  BD_RESOURCES_LIST_OPTIONS_FILTER_FNC_DEFAULT,
  BdResourcesListConfig,
} from '../../list/list-options.model';
import {
  BdResource,
  BdSharePermission,
} from '@bindoc-projects/resource-domain-lib';

export interface BdResourcesSelectInlineConfig<
  TResource extends BdResource = BdResource,
> extends BdResourcesListConfig<TResource> {
  resourceNameTitle: string;
  selectOnInit: 'none' | 'first';
  resetOption: boolean;
  minPermission?: BdSharePermission;
}

export const BD_RESOURCES_SELECT_INLINE_CONFIG_DEFAULT: BdResourcesSelectInlineConfig =
  {
    disableFnc: BD_RESOURCES_LIST_OPTIONS_DISABLE_FNC_DEFAULT,
    detailLinkFnc: BD_RESOURCES_LIST_OPTIONS_DETAIL_LINK_FNC_DEFAULT,
    filterFnc: BD_RESOURCES_LIST_OPTIONS_FILTER_FNC_DEFAULT,
    emptyResourcesText: 'Keine Elemente gefunden',
    resourceNameTitle: 'Element',
    selectOnInit: 'none',
    resetOption: true,
  };
